$(function() {

  // Cache stuff
  var $nav = $('.shopify-header-bar');
  var $widget_subscribe = $('#WidgetSubscribe');

  var NAV_HEIGHT = $nav.height();


	// Misc functions
	$.fn.outerHTML = function() {
	  return $(this).clone().wrap('<div></div>').parent().html();
	}

	// Comments, scroll down to comment area if there was a message
	if ($('.error-msg').length) $(window).scrollTop($('.error-msg').position().top - 200);
	if ($('.success-msg').length) $(window).scrollTop($('.success-msg').position().top - 200);

	// Lightbox
	$("a.fancybox").fancybox({
		'transitionIn'  : 'fade',
		'transitionOut' : 'fade'
	});
	if ($('*[class*="fancybox.iframe"]').length)
	{
		$('*[class*="fancybox.iframe"]').fancybox({
			maxWidth	: 800,
			maxHeight	: 450,
			fitToView	: false,
			width		: '70%',
			height		: '70%',
			autoSize	: false,
			closeClick	: false,
			openEffect	: 'fade',
			closeEffect	: 'fade'
		});
	}

    // Email Form to Two Locations
    function emailRegister(evt) {
      evt.preventDefault();

      var $form = $(evt.currentTarget);
      var email_address = $form.find('[type="email"]').val();

      if (email_address) {
        $.ajax({
          type: $form.attr('method'),
          url: $form.attr('action'),
          data: $form.serialize(),
          cache       : false,
          dataType    : 'json',
          contentType: "application/json; charset=utf-8",
          error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
          success     : function(data) {
            if (data.result != "success") {
              $('#mailchimp-fail').fadeIn(300).animate({delay: 1}, 2000).fadeOut(300);
            } else {
              $('#mailchimp-success').fadeIn(300);
              $('#mailchimp-close').fadeIn(300);
              if (window._cio) {
                _cio.identify({
                  id: email_address,
                  email: email_address,
                  created_at: Date.now() / 1000,
                });
                _cio.track('subscribed', {
                  source: 'blog_sidebar'
                });
              }
            }
          }
        });
      }
    }

    $('.js-email-subscribe').on('submit', emailRegister);

	$('#mailchimp-success').click(function () {
		$('#mailchimp-success').fadeOut(300);
        $('#mailchimp-close').fadeOut(300);
	});

	$('#mailchimp-close').click(function () {
		$('#mailchimp-success').fadeOut(300);
        $('#mailchimp-close').fadeOut(300);
	});


  // Sticky navigation
  $(window).load(function() {
    $('#content-with-sidebar').waypoint(function(direction) {
      if (direction == 'down') {
        $widget_subscribe.addClass('fixed').fadeIn(200);
      } else {
        $widget_subscribe.removeClass('fixed');
      }
    }, { offset: NAV_HEIGHT });

    $('#shopify-footer').waypoint(function(direction) {
      if (direction == 'down') {
        $widget_subscribe.fadeOut(200);
      } else {
        $widget_subscribe.addClass('fixed').fadeIn(200);
      }
    }, { offset: 600 });
  });

				$(window).load(function(){
					if ($(window).height() <= 700 || $(document).height() <= 3000 ) {
		      }
		 			else
						{
							$('#content-with-sidebar').waypoint(function(direction) {
								if (direction == 'down') {
									$('#backtotop-btn').css({ position: "fixed", left:"50%", margin: "0px 0px 0px 257px", top:"auto"}).fadeIn(500);
								}
		            else {
									 $('#backtotop-btn').fadeOut(50);
		            }
		        }, { offset: 0 });
		        $('#shopify-footer').waypoint(function(direction) {
		            if (direction == 'down') {
											 $('#backtotop-btn').fadeOut(50);
		            }
		            else {
										 $('#backtotop-btn').fadeIn(200);
		            }
		            }, { offset: 1600 });
		        }
		    });



			$('#backtotop-btn').click(function () {
				$('body,html').animate({
					scrollTop: 0
				}, 1300);
				return false;
			});



	fixed_share();

	// Move feature image out of content and into crop box above content (also removes any parent tags of the image that the wysiwyg might have inserted)
	if ($('.post .featured-image').length)
	{
		$('.post').each(function() {
			var feature_img = $(this).find('.post-content img[alt="feature"]');
			var img_position = "center";

			// Remove parent tags
			if (!feature_img.parent().hasClass('post-content')) feature_img.unwrap();
			if (!feature_img.parent().hasClass('post-content')) feature_img.unwrap();
			if (!feature_img.parent().hasClass('post-content')) feature_img.unwrap();
			if (!feature_img.parent().hasClass('post-content')) feature_img.unwrap();

			if (feature_img.attr("style","margin-top: 1px;")) img_position = "top";

			destination = feature_img.parents('.post:first').find('.featured-image');
			feature_img
				.remove()
				.attr("style","")
				.hide()
				.appendTo(destination);

			// Remove trailing <br>
			if ($(this).find('.post-content *:first-child:first').outerHTML() == "<br>") $(this).find('.post-content *:first-child:first').remove();

			// Get image size and center it
			if (img_position == "center")
			{
				$("<img/>").attr("src", $(feature_img).attr("src")).load(function() {
					new_height = this.height / this.width * $('.featured-image').width();
					feature_img.css("margin-top", -(new_height - $('.featured-image').height()) / 2);
					feature_img.fadeIn(100);
			    });
			}
			else if (img_position == "top")
			{
				feature_img.fadeIn(100);
			}
		});
	}

	// Short post featured image (not efficient)
	if ($('.post-short').length)
	{
		$('.post-short').each(function() {
			var img = $(this).find('.fetch-image img:first');
			if (img.length)
				img.remove().appendTo($(this).find('.featured-image'));
			else
				$(this).find('.featured-image').addClass('no-image');
		});
	}

	// If coming from our site, preserve the nav and CTA
	var from_site = 0;
	if (!$.cookie('from_site'))
    {
        if (document.referrer.indexOf('www.shopify.') != -1)
    	{
    		$.cookie('from_site', '1', { path: '/' });
    		$('body').addClass('from-site');
    	}
        else
        {
        	$.cookie('from_site', '0', { path: '/' });
        	$('body').addClass('from-other');
        }
    }
    // If they enter directly to the blog, then browse to the site, then return to the blog, make sure cookie is reset
    if ($.cookie('from_site') == '0' && document.referrer.indexOf('www.shopify.') != -1 && document.referrer.indexOf('www.shopify.com/blog') == -1)
    {
        $.cookie('from_site', '1', { path: '/' });
        $('body').removeClass("from-other").addClass('from-site');
    }

    // Read cookie, set classes
	if ($.cookie('from_site') == '1')
		$('body').addClass('from-site');
    else if ($.cookie('from_site') == '0')
    	$('body').addClass('from-other');

	// --- Post content scripts -------------------

  

	// Fix YouTube z-index Chrome issue
	$('.post-content iframe[src*="youtube.com"]').each(function() {
		var url = $(this).attr("src");
		$(this).attr("src",url+"?wmode=transparent");
	});

});

// Fly-out sharing box at top of post (Optimizely trigger)
function fixed_share()
{
  var $share = $('.share');
  var $window = $(window);
	if ($share.length) {

		$share.addClass('share-fixed-2');

		$window.scroll(function() {
			var post_top = $(".post-content").position().top - 100;
			var content_bottom = $("#content-with-sidebar").position().top + $("#content-with-sidebar").height() - 200;
			var past_threshold = (($window.scrollTop() > post_top) && ($share.position().top + $share.height() < content_bottom));
			if (!$share.hasClass("open") && past_threshold)
				$share.addClass("open").stop().css({ opacity: 1 }).animate({ width: 160, marginLeft: "-195px" }, { duration: 200, easing: "linear" });
			else
			{
				if ($share.hasClass("open") && !past_threshold)
					$share.removeClass("open").stop().animate({ width: 0, marginLeft: "-35px", opacity: 0 }, { duration: 200, easing: "linear" });
			}
		});
	}
	$window.resize(function() {
    if ($window.width() < 667 || Modernizr.mq('(max-device-width: 667px)') ) {
      $share.hide();
    } else {
      $share.show();
    }

    if ($window.width() < 1380) {
      $share.addClass('share-fixed');
    } else {
      $share.removeClass('share-fixed');
    }
	});
	$window.resize();
}
